import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const cmds = editor.Commands;

  const CMDS = window.PMW.emails.commands;

  cmds.add(CMDS.OPEN_ADD_BLOCKS_DIALOG, {
    run() {
      const dlg = window.PMW.openModalDialog(window.PMW.emails.blocks.ID_ADD_BLOCKS_DIALOG, window.i18next.t('pmwjs_add_to_email'), null, false, '-modal-100');

      const blocksManagerContainerId = window.PMW.emails.blocks.ID_BLOCKS_MANAGER_CONTAINER;
      let blocksManagerContainer = document.getElementById(blocksManagerContainerId);

      if (!blocksManagerContainer) {
        blocksManagerContainer = document.createElement('div');
        blocksManagerContainer.id = blocksManagerContainerId;

        window.PMW.renderEmailMakerBlockManager(blocksManagerContainer, {gjsEditor: editor});
      }

      dlg.find('.modal-content').html(blocksManagerContainer);
    },
  });

  cmds.add(CMDS.CLOSE_ADD_BLOCKS_DIALOG, {
    run() {
      void window.PMW.closeModalDialog(window.PMW.emails.blocks.ID_ADD_BLOCKS_DIALOG);
    },
  });
};
